import { productStats } from "@/mocks/products";

export default function ProjectsHero() {
  return (
    <section className="relative w-full min-h-[60vh] flex flex-col justify-end">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1920&q=80"
          alt="Projelerimiz"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/85 via-[#1E3A8A]/45 to-[#1E3A8A]/15"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 w-full pb-16 pt-32">
        <div className="flex items-center gap-3 mb-5">
          <div className="h-px w-12 bg-[#3B82F6]"></div>
          <span className="text-[#B8C5D8] text-xs font-semibold tracking-[0.3em] uppercase">Ürün Kataloğu</span>
        </div>
        <h1 className="text-white font-black uppercase leading-none mb-8"
          style={{ fontSize: "clamp(36px, 6vw, 80px)", letterSpacing: "-0.02em" }}
        >
          Kurumsal<br />
          <span className="text-transparent" style={{ WebkitTextStroke: "1.5px #93C5FD" }}>Teknoloji</span><br />
          Ürünleri
        </h1>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl">
          {productStats.map((stat, i) => (
            <div key={i} className="border border-[#E2E8F0] bg-white/90 backdrop-blur-sm p-5">
              <p className="text-[#0F172A] font-black text-xl md:text-2xl leading-tight">{stat.value}</p>
              <p className="text-[#64748B] text-xs tracking-wide mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
